import { months } from "../assets/static/month";
import { languages } from "../assets/static/language";
import { shareOptions } from "../assets/static/share-options";
export const state = () => ({
    months,
    languages,
    shareOptions,
});
